"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { BookOpen, Brain, Users } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CoreServicesOverview() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const services = [{
    icon: BookOpen,
    title: "ELA & Core Subjects",
    description: "Personalized instruction in English language arts, science, and social studies tailored to each student's unique learning needs.",
    link: "/ServicesPage",
    colorClass: "text-primary",
    bgClass: "bg-primary/10"
  }, {
    icon: Brain,
    title: "AI-Driven Assessments",
    description: "Advanced technology and artificial intelligence tools to measure progress and adapt instruction for measurable outcomes.",
    link: "/ServicesPage",
    colorClass: "text-secondary",
    bgClass: "bg-secondary/10"
  }, {
    icon: Users,
    title: "Behavioral Support",
    description: "Compassionate, expert guidance for students with special education behavioral issues in mobile and virtual environments.",
    link: "/ServicesPage",
    colorClass: "text-primary",
    bgClass: "bg-primary/10"
  }];
  return <section ref={sectionRef} className="bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className={`font-display text-3xl font-bold text-foreground-light sm:text-4xl transition-all duration-[var(--duration-medium)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Core Services Overview
          </h2>
          <p className={`mt-4 text-muted-foreground transition-all duration-[var(--duration-medium)] delay-100 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Technology-enhanced special education services designed for K-12
            students
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className={`flex flex-col border-none rounded-lg bg-background shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: sectionVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardHeader className="pb-4">
                  <div className={`mb-4 flex size-12 items-center justify-center rounded-md ${service.bgClass}`}>
                    <Icon className={`size-6 ${service.colorClass}`} aria-hidden="true" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground-light">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex flex-1 flex-col justify-between gap-4">
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                  <Link to={service.link}>
                    <Button className="w-full min-h-[44px] bg-action text-white rounded-md shadow-sm hover:bg-action-hover hover:scale-[1.02] hover:shadow-medium active:bg-action-active active:scale-100 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] cursor-pointer">
                      Learn More
                    </Button>
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}